var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sponsor has-text-centered",attrs:{"target":"_blank","href":_vm.url}},[_c('img',{staticClass:"img-responsive",style:('transform: scale(' + _vm.scale + ');'),attrs:{"src":'../../../static/sponsors/' + _vm.image}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fbaf5f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/presentation/sponsor/Sponsor.vue
// module id = null
// module chunks = 